import {ActiveEvents}      from "@Common/react/active-events";
import {cs}                from "@Common/react/chain-services";
import {fragments}         from "@Common/react/fragments";
import {GlobalMouseMove}   from "@Common/react/global-mouse-move";
import {GlobalMouseUp}     from "@Common/react/global-mouse-up";
import {GlobalTouchCancel} from "@Common/react/global-touch-cancel";
import {GlobalTouchEnd}    from "@Common/react/global-touch-end";
import {GlobalTouchMove}   from "@Common/react/global-touch-move";
import {Invoke}            from "@Common/react/invoke";
import {UseState}          from "@Common/react/use-state";
import {chain}             from "@Common/utils/fs";

import {eventToPos} from "./event-to-pos";
import {OnUnmounted} from "@Common/react/on-unmounted";

export const Dragging = ({next}) => cs(
    ["state", (_, next) => UseState({next})],
    ["events", ({state}, next) => ActiveEvents({
        events: {
            onTouchStart: (e) => {
                e.preventDefault();
                e.stopPropagation();

                state.onChange({
                    oriPos: eventToPos(e.touches[0]),
                });
            },
        },
        next,
    })],
    ({state, events}) => next({
        active: state.value,
        // ref: events.ref,
        handle: {
            onMouseDown: (e) => {
                e.preventDefault();
                e.stopPropagation();
                state.onChange({
                    oriPos: eventToPos(e),
                });
            },
            ref: events.ref,
        },

        renderActive: ({onDone=undefined, modDelta=undefined, onStart=undefined, onChange=undefined}) => fragments(
            OnUnmounted({
                action: events.reset,
            }),
            state.value && fragments(
                onStart && (
                    Invoke({
                        action: () => onStart({oriPos: state.value.oriPos}),
                    })
                ),
                GlobalTouchCancel({
                    action: () => {
                        state.onChange(null);
                    },
                }),

                (() => {
                    const action = () => {
                        if (state.value.delta && onDone) {
                            onDone(state.value.delta);
                        }
                        state.onChange(null);
                    };
                    return fragments(
                        GlobalMouseUp({
                            action,
                        }),
                        GlobalTouchEnd({
                            action,
                        }),
                    );
                })(),

                (() => {
                    const action = (newPos) => {
                        const delta = chain(
                            deltaPos(newPos, state.value.oriPos),
                            (p) => !modDelta ? p : modDelta(p),
                        );
                        state.change((s) => s && ({
                            ...s,
                            delta,
                        }));
                        onChange?.(delta);
                    };
                    return fragments(
                        GlobalMouseMove({
                            action: (e) => action(eventToPos(e)),
                        }),
                        GlobalTouchMove({
                            action:(e) => action(eventToPos(e.touches[0])),
                        }),
                    );
                })(),
            ),
        ),
    }),
);


const deltaPos = (p1, p2) => ({
    x: p1.x - p2.x,
    y: p1.y - p2.y,
});
